import type { Directive } from 'vue'

export const autoFocus: Directive = {
  mounted(el) {
    setTimeout(() => {
      if (el.querySelector('.el-input__inner') != null) {
        el.querySelector('.el-input__inner').focus()
        return
      }
      el.querySelector('.el-textarea__inner').focus()
    }, 0)
  },
}

export const blur: Directive = {
  mounted(el) {
    el.addEventListener('focus', (e) => {
      e.target.blur()
    })
  },
}
